import React from 'react';
import { Link } from 'react-router-dom';
import numeral from 'numeral';
import { Button, FormGroup, Input, Label } from 'reactstrap';
import api from '../../api';
import './index.css';

export default class SiteSummaryView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      site: this.props.site,
    };
  }
  render() {
    const { site } = this.state;
    return (
      <div
        className="map_selected_location"
      >
        {(site.brand || site.brand_name) &&
          <span className="map_selected_location__text brand">{site.brand_name || site.brand.name}<br /></span>
        }
        <span className="map_selected_location__text">{ site.name || site.address || '' }</span><br />
        {site.location_type &&
          <span className="map_selected_location__text">Loại: {site.location_type_name || site.location_type.name}<br /></span>
        }
        {site.distance_in_km &&
          <span className="map_selected_location__text">Khoảng cách tới địa điểm đang chọn: {numeral(site.distance_in_km * 1000).format('0,00')} m</span>
        }
        <div className="map_selected_location__actions">
          <Button tag={Link} color="info" size="sm" to={`/site/${site.id}/edit`}>Chỉnh sửa địa điểm này</Button>
          <Button color="warning" size="sm" onClick={() => this.props.onBackClick()}>Quay lại bản đồ</Button>
        </div>
      </div>
    )
  }
}